/* eslint-disable max-len */
export const adminMessages = {
    'Admin.Dashboard.Playground.title': 'Dashboard Playground',
    'Admin.FormBuilder.ContextManager.application':
        'Application (compiled from available recipes)',
    'Admin.FormBuilder.ContextManager.description':
        'Select a tenant and application to add to the Form context. This will primarily be used for testing Workato-based dynamic loader fields.',
    'Admin.FormBuilder.ContextManager.title': 'Form Context Manager',
    'Admin.FormBuilder.description': 'Build a form.',
    'Admin.FormBuilder.field.add': 'Add field',
    'Admin.FormBuilder.field.definition': 'Field Schema',
    'Admin.FormBuilder.field.edit': 'Edit field',
    'Admin.FormBuilder.field.form': 'Form preview',
    'Admin.FormBuilder.field.remove': 'Remove field',
    'Admin.FormBuilder.payload': 'Payload preview',
    'Admin.FormBuilder.submit': 'Submit form',
    'Admin.FormBuilder.title': 'Form builder',
    'Admin.Manifests.current': 'Current Manifests',
    'Admin.Manifests.deploy': 'Deploy',
    'Admin.Manifests.description':
        'View and upload Workato manifests and deploy manifests to customers',
    'Admin.Manifests.newRecipes.description':
        'Select this if you’re adding new API endpoints or connectors. Leave it unchecked if the uploaded manifest only includes updates of existing recipes.',
    'Admin.Manifests.newRecipes.title': 'Recipes added/removed',
    'Admin.Manifests.title': 'Manage Manifests',
    'Admin.Manifests.update.allTenants.message':
        'This will deploy <strong>{{manifestFilePath}}</strong> to all {{region}} SaaS Ops tenants.',
    'Admin.Manifests.update.error':
        'Something went wrong with the manifest update.',
    'Admin.Manifests.update.selectTenants.message':
        'This will deploy <strong>{{manifestFilePath}}</strong> to the following {{region}} SaaS Ops tenants.',
    'Admin.Manifests.update.success': 'Manifest update successfully queued.',
    'Admin.Manifests.upload': 'Upload Manifest',
    'Admin.Manifests.upload.fail': 'Failed to upload manifest',
    'Admin.Manifests.upload.success': 'Manifest uploaded succesfully!'
};
